import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-checkmark',
  template: `<img [src]="'assets/checkmark.png'" width="64" height="64" [alt]="alt" />`,
  encapsulation: ViewEncapsulation.None,
  imports: [EmailImageAssetDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
})
export class EmailCheckmarkComponent {
  @Input() public alt: WrappedValue<string>;
}
